module.exports = __webpack_public_path__ + "img/network_device-1.c93c9967.webp";